import * as React from "react"
import { Skeleton} from "@mui/material";
import {CountUpSeeker, WidgetSeeker} from "@ui-seeker/core";
import {formatPercentage, isEmpty} from "@ui-seeker/utils";

import {useUserActivityCards} from "../@hooks";
import {isLoadingCards} from "../@signals";


export default function UserActivityCards({ api, title }) {
    const { data, dataPrev, diff } = useUserActivityCards(api)

    if (isLoadingCards.value) return <Skeleton variant="rectangular" height={100} />
    if (isEmpty(data) && isEmpty(dataPrev)) return <></>

    return <WidgetSeeker
        title={title}
        subtitle={<CountUpSeeker end={data} />}
        previous={<CountUpSeeker end={dataPrev} />}
        diff={<CountUpSeeker end={diff} formattingFn={formatPercentage}/>}
        diffValue={diff}
    />
}